import { getViewEnum } from "src/common/helpers";

export enum ProductTypeEnum {
  Terminal = 1,
  Cashier,
};

export const ProductTypeViewEnum = getViewEnum(ProductTypeEnum);